import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  getOrder,
  getMission,
  updateOrderStatus,
  mergeOrders,
  getMergedOrders,
  rejectOrder,
  refundOrder,
  resetOrder,
  clearSelectedOrder,
  addNoteToOrder,
  moveOrderAcceptedForTime,
  getAdminConfig,
  getCells,
  getMerchantsInCell,
  setSelectedCell,
  setRefreshInterval,
  setOrderWithinTimeFilter,
  setRouteConfirmationOrder,
  setSelectedOrderId,
  getCellCommercialConfig,
  getLandingZonesInCell,
  setInvalidatingAnOrderDropLocation,
  setUseSSEForOrders,
  setShowCompletedCancelledOrders,
  acceptOrder
} from 'actions/orderActions';
import { Teams } from './Teams';
import { getGeofences } from 'actions/geofenceActions';
import getTabConfig from '../../getUserRolesForTabs';
import {
  Paper,
  Tabs,
  Tab,
  Checkbox,
  Box,
  FormGroup,
  FormControlLabel,
} from '@mui/material';

import OrderDetails from './OrderDetails';
import OrdersMap from './OrdersMap';
import Availability from './Availability';
import {
  getPointOfSales,
  getRegions,
} from 'actions/adminActions';
import { newNotification } from 'actions/uiActions';
import { updateLandingZoneLocally } from '../../actions/orderActions';
import { canChangeLandingZone } from '../../utils/orderUtils';

import {
  getLandingPads,
  subscribeToMessaging
} from 'actions/liveAircraftActions';
import {
  selectFilteredOrders,
  selectNewOrders,
  selectOrderDetails,
  selectOrdersWithinTime,
  selectPreparedOrders,
  selectPreparingOrders,
  selectReadyToGoOrders,
  selectReceivedOrders,
  selectRouteConfirmationOrder,
  selectSelectedOrderId,
  selectToAcceptOrders,
  selectWithOutletOrders,
  selectShowCompletedCancelledOrders
} from 'selectors/ordersSelector';
import { usePadsWithRetry } from '../../hooks/usePadsWithRetry';
import { useWindowSize } from 'utils/hooks';
import { useOrderSSE2 } from '../../hooks/useOrderSSE2';
import { useOrderAlertsSSE } from '../../hooks/useOrderAlertsSSE';
import { useAppSelector } from 'hooks/redux';
import { CustomView } from './CustomView';
import { UpcomingOrders } from './UpcomingOrders';
import RouteConfirmation from './RouteConfirmation';
import { OrderList } from './components/OrderList';
import { OrderHubHeader } from './components/OrderHubHeader';
import { Swimlanes } from '../../constants/orderConstants';
import CellAvailabilityOverview from '../Calendar/CellAvailabilityOverview';
import { OrderAlertsPopup } from '../../components/OrderAlertsPopup';
import { getShortIdForOrder, shouldShowDropPointConfirmationForOrder, isExtraDeliveryOrder } from '../../utils/orderUtils';
import SearchModal from '../../components/SearchModal/SearchModal';
import { AddressFind, DropLocation, LandingZone, Order, OrderSummary } from '@m4a3/api-client';
import SuggestedDropPointConfirmationModal from './components/SuggestedDropPointConfirmationModal';
import { PlaceDropPointModal } from '../../components/PlaceDropPointSelector';
import { API } from 'aws-amplify';
import { logToDatadog } from '../../services/datadog';
import { blanchCellId, espooCellId, junction6CellId, kerryCellId } from '../../constants';
import { getObstacles } from '../../actions/obstacleActions';
import { withRetry } from '../../utils/utils';
import { deliveryApi, orderfulApi } from '../../services/api-instances';
import { getAllLandingZonesForCell } from '../../utils/getAllLandingZonesForCell';
import NewRouteConfirmation from './NewRouteConfirmation';
import Button from '@mui/material/Button';

// Used with level 5
const newOrderSound = new Audio(require('../../assets/new-order.mp3'));
newOrderSound.volume = 1;
const newOrderReceivedSound = new Audio(require('../../assets/beep-6-96243.mp3'));
newOrderReceivedSound.volume = 1;

function a11yProps(index: number) {
  return {
    id: `orderhub-tab-${index}`,
    'aria-controls': `orderhub-tabpanel-${index}`
  };
}

type OrderHubProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & {
  useSSEForOrders: boolean;
};

const OrderHub = ({
  getGeofences,
  clearSelectedOrder,
  timeFilter,
  getAdminConfig,
  getCells,
  getMerchantsInCell,
  cells,
  setSelectedCell,
  selectedCellId,
  getRegions,
  setRefreshInterval,
  refreshInterval,
  setOrderWithinTime,
  geofences,
  obstacles,
  notify,
  useSSEForOrders,
  setShowCompletedCancelledOrders,
  acceptOrder
}: OrderHubProps) => {

  const size = useWindowSize();

  const backGardenCellIds = [junction6CellId, blanchCellId, kerryCellId];
  const isBackGardenDelivery = backGardenCellIds.includes(selectedCellId);
  const currentOrders = useSelector(selectOrdersWithinTime);

  const [selectedTab, setSelectedTab] = useState(0);
  const [edit, setEdit] = useState(false);
  const [tabConfig, setTabConfig] = useState([]);
  const [isSuggestModalOpen, setIsSuggestModalOpen] = useState(false);
  const [shouldShowSearchModal, setShouldShowSearchModal] = useState(false);
  const [showCustomTab, setShowCustomTab] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [addressInfoForOrderMap, setAddressInfoForOrderMap] = useState<{[key: string]: AddressFind}>({});
  const [oldOrdersData, setOldOrdersData] = useState<OrderSummary[]>([]);
  const [isSearchingOldOrders, setIsSearchingOldOrders] = useState(false);
  const [landingZonesByCell, setLandingZonesByCell] = useState<{ [cellId: number]: LandingZone[] }>({});
  const [routeConfirmationVariant, setRouteConfirmationVariant] = useState<'new' | 'deprecated'>('new');
  
  // Local modal state instead of Redux
  const [modalState, setModalState] = useState<{
    type: 'route' | 'dropPoint' | null;
    order: Order;
  }>({ type: null, order: null });
  
  const newOrders = useSelector(selectNewOrders);
  const withOutletOrders = useSelector(selectWithOutletOrders);
  const readyToGoOrders = useSelector(selectReadyToGoOrders);
  const toAcceptOrders = useSelector(selectToAcceptOrders);
  const preparingOrders = useSelector(selectPreparingOrders);
  const preparedOrders = useSelector(selectPreparedOrders);
  const receivedOrders = useSelector(selectReceivedOrders);
  const filteredOrders = useSelector(selectFilteredOrders);
  const currentlySelectedOrderId = useAppSelector(selectSelectedOrderId);
  const currentlySelectedOrdersOrderDetails = useAppSelector(selectOrderDetails);
  const showCompletedCancelledOrders = useSelector(selectShowCompletedCancelledOrders);
  const { pads, isLoading: padsLoading, error: padsError } = usePadsWithRetry();

  const sinceMinutesQueryRef = useRef(120);
  const currentOrderId = useRef(currentlySelectedOrderId);
  const dispatch = useDispatch();
  const adminConfigInterval = useRef<NodeJS.Timer>();
  const ordersIntervalRef = useRef<NodeJS.Timer>();
  const pollingIntervalSecondsRef = useRef(30);
  
  const isInitialMount = useRef(true);
  const previousOrderIds = useRef<Set<string>>(new Set());
  const previousCellId = useRef<number | null>(null);
  const previousStatusRef = useRef<Map<string, string>>(new Map());

  const { isConnected, error } = useOrderSSE2(selectedCellId, undefined, useSSEForOrders);
  
  // Order Alerts SSE connection
  const {
    alerts,
    isConnected: alertsConnected,
    error: alertsError,
    clearAlerts,
    dismissAlert
  } = useOrderAlertsSSE(selectedCellId, undefined, true, true); // Using local endpoint for now
  
  useEffect(() => {

    // Only show errors and respond to WebSocket events if we're using WebSocket mode
    if (useSSEForOrders && !isConnected && error) {
      logToDatadog('orderhub_SSE_disconnected');
    } else {
      logToDatadog('orderhub_SSE_connected');
    }
  }, [isConnected, error, notify]);
  
  // Always poll for admin config regardless of websocket mode
  useEffect(() => {
    if (refreshInterval !== 0) {
      getAdminConfig();
      const interval = setInterval(() => {
        getAdminConfig();
      }, (pollingIntervalSecondsRef.current || 5) * 1000);
      return () => clearInterval(interval);
    }
  }, [refreshInterval, getAdminConfig]);

  // Polling for orders is disabled; SSE is the primary source of truth
  // This effect is intentionally removed to avoid manual refreshes

  useEffect(() => {
    dispatch(getLandingPads());
    dispatch(subscribeToMessaging());
    dispatch(setUseSSEForOrders(useSSEForOrders));
    getTabConfig('OrderHub', showCustomTab).then(setTabConfig);

    // Pull time filter from local storage and set 
    const storedSinceMinutesFilter = sessionStorage.getItem('sinceMinutes');
    if (storedSinceMinutesFilter) {
      sinceMinutesQueryRef.current = parseInt(storedSinceMinutesFilter);
    }
    getRegions();
    getCells();
    getMerchantsInCell(selectedCellId);
    getGeofences();
    getCellCommercialConfig(selectedCellId);

    return () => {
      clearPolling();
      // Reset SSE mode when component unmounts
      dispatch(setUseSSEForOrders(false));
    };
  }, [showCustomTab]);

  useEffect(() => {
    if (currentlySelectedOrderId !== currentOrderId.current && selectedTab !== 5) {
      currentOrderId.current = currentlySelectedOrderId;
      if (currentlySelectedOrderId) {
        setSelectedTab(1);
      }
    }
  }, [currentlySelectedOrderId]);

  // Sound notification system: Tracks order IDs to detect new orders and play appropriate sounds
  // Handles both regular orders (CREATED) and auto-accepted orders (STORE_ACCEPTED)
  useEffect(() => {
    // Check if we've switched to a different cell
    const cellHasChanged = previousCellId.current !== null && previousCellId.current !== selectedCellId;
    
    // Handle cell change - reset tracking without playing sounds
    if (cellHasChanged) {
      previousCellId.current = selectedCellId;
      previousOrderIds.current = new Set(currentOrders?.map(order => order.id) || []);
      previousStatusRef.current = new Map((currentOrders || []).map(order => [order.id, order.status]));
      logToDatadog('checking_address_info_step_0', {});
      return; // Exit early, no sounds on cell change
    }
    
    // Skip sound on initial mount/load to avoid noise when page first loads
    if (!isInitialMount.current) {
      // Get current order IDs
      const currentOrderIds = new Set(currentOrders?.map(order => order.id) || []);
      
      // Find truly NEW orders (not in previous set)
      const newOrders = currentOrders?.filter(order => 
        !previousOrderIds.current.has(order.id)
      ) || [];
      
      // Play sound for new orders that are either CREATED or ACCEPTED/STORE_ACCEPTED
      // Note: We check for ACCEPTED/STORE_ACCEPTED because when auto-accept is enabled,
      // orders skip the CREATED status and arrive directly as ACCEPTED/STORE_ACCEPTED.
      // We still want to notify users of these new auto-accepted orders.
      const newOrdersToNotify = newOrders.filter(order => 
        (order.status === 'CREATED' || 
        order.status === 'ACCEPTED' ||
        order.status === 'STORE_ACCEPTED') &&
        !isExtraDeliveryOrder(order)
      );
      
      if (newOrdersToNotify.length > 0) {
        try {
          newOrderSound.play();
        } catch (error) {
        // noop - this throws an error if a user hasn't interacted with the page before we try to play
        }
      }
      
      // Play sound for transitions to RECEIVED_FROM_STORE 
      const receivedTransitions = (currentOrders || []).filter(order => {
        const prev = previousStatusRef.current.get(order.id);
        return prev !== 'RECEIVED_FROM_STORE' && order.status === 'RECEIVED_FROM_STORE';
      });

      if (receivedTransitions.length > 0) {
        try {
          newOrderReceivedSound.play();
        } catch (error) {
        }
      }

      // Update the previous order IDs and statuses for next comparison
      previousOrderIds.current = currentOrderIds;
      previousStatusRef.current = new Map((currentOrders || []).map(order => [order.id, order.status]));
    } else {
      // On initial mount: reset tracking without playing sounds
      isInitialMount.current = false;
      previousCellId.current = selectedCellId;
      previousOrderIds.current = new Set(currentOrders?.map(order => order.id) || []);
      previousStatusRef.current = new Map((currentOrders || []).map(order => [order.id, order.status]));
    }
    
    logToDatadog('checking_address_info_step_0', {});
  }, [currentOrders]); 

  useEffect(() => {
    if (cells && cells.length !== 0) {
      try {
        const cellId = parseInt(localStorage.getItem('selectedCell'));
        if (cellId) {
          setSelectedCell(cellId, useSSEForOrders);
        } else if (cells && cells[0]) {
          const blanchardstownCell = cells.find(
            c => c.cellName.toLowerCase() === 'blanchardstown'
          );
          setSelectedCell(blanchardstownCell.id, useSSEForOrders); // default to blanchardstown
        }
      } catch (err) {
        console.log(err);
      }
    }
  }, [cells]);

  useEffect(() => {
    if (selectedCellId) {
      dispatch(getPointOfSales(selectedCellId));
      dispatch(getObstacles(selectedCellId));
      dispatch(getLandingZonesInCell(selectedCellId));
    }
  }, [selectedCellId]);

  // Lazily fetch and cache landing zones per cell for dropdowns in OrderCards
  useEffect(() => {
    const fetchZonesForSelectedCell = async () => {
      if (!selectedCellId || !cells || cells.length === 0) return;
      if (landingZonesByCell[selectedCellId]) return; // Already cached

      try {
        const currentCell = cells.find(c => c.id === selectedCellId);
        if (!currentCell) return;
        const zones = await getAllLandingZonesForCell([currentCell]);
        setLandingZonesByCell(prev => ({ ...prev, [selectedCellId]: zones }));
      } catch (e) {
        // Ignore for now; UI can still render without zones
      }
    };

    fetchZonesForSelectedCell();
  }, [selectedCellId, cells, landingZonesByCell]);

  const clearPolling = () => {
    clearInterval(adminConfigInterval.current);
    clearInterval(ordersIntervalRef.current);
  };

  const onChangeTab = (_evt, tab) => {
    setSelectedTab(tab);
  };

  const _setSinceMinutes = mins => {
    setOrderWithinTime(mins);
  };

  const handleSinceMinutesQuery = evt => {
    _setSinceMinutes(evt.target.value);
    clearSelectedOrder();
    setSelectedTab(0);
  };

  const handleCellUpdate = evt => {
    localStorage.setItem('selectedCell', evt.target.value);
    dispatch(setSelectedOrderId(null));
    setSelectedCell(evt.target.value, useSSEForOrders);
  };

  const handleRefreshTimeChange = evt => {
    const refreshTime = evt.target.value;
    if (refreshTime === 0) {
    }

    setRefreshInterval(refreshTime);
  };

  const changeEditMode = () => {
    setEdit(!edit);
  };

  const onClickShowSuggestedDropModalForOrder = (orderId: string) => {
    API.get('api', `/order/${orderId}`, {})
      .then((order) => {
        dispatch(setRouteConfirmationOrder(order));
        dispatch(setSelectedOrderId(orderId))

        setModalState({
          type: 'dropPoint',
          order: order
        });
      })
      .catch((err) => {
        closeSuggestedDropPointConfirmationModal();
        logToDatadog('error_getting_order_details', {err}, 'error');
        notify({
          variant: 'error',
          message: 'Error getting order details'
        });
      });
  };

  const onClickInvalidateDropLocation = (orderId: string, locationId: string) => {
    dispatch(setInvalidatingAnOrderDropLocation(true));

    deliveryApi.getDropLocationInfo(locationId).then((dropLocationInfo) => {
      const currentDropLocationInfo = dropLocationInfo;

      if (currentDropLocationInfo) {
        const dropLocationId = dropLocationInfo?.id;
        const suggestedDropLocations = currentDropLocationInfo?.suggestedDropLocations;

        const dropLocationsToInvalidate = currentDropLocationInfo?.dropLocation ? [currentDropLocationInfo?.dropLocation, ...suggestedDropLocations.filter((dropLocation: DropLocation) => dropLocation.id !== currentDropLocationInfo?.dropLocation.id)] : suggestedDropLocations;

        handleRequestDropLocationReview(dropLocationId, dropLocationsToInvalidate, orderId);
      } else {
        logToDatadog('error_onClickInvalidateDropLocation', {}, 'error');
        notify({
          variant: 'error',
          message: 'Error Invalidating Drop Location'
        });
      }
    })
    .catch((error) => {
      dispatch(setInvalidatingAnOrderDropLocation(false));
      closeSuggestedDropPointConfirmationModal();
      logToDatadog('error_onClickInvalidateDropLocation', {error}, 'error');
      notify({
        variant: 'error',
        message: 'Error Invalidating Drop Location'
      });
    })
  };

  const handleRequestDropLocationReview = async (
    dropLocationInfoId: string,
    dropLocations: DropLocation[],
    orderId: string,
  ) => {

    try {

      const reason = selectedCellId === espooCellId ? "MC_invalidated_drop_in_espoo" : "MC forced drop location invalidation";

      const address = await withRetry(() => orderfulApi.getAddressFindById(dropLocationInfoId));

      const updatedAddress = {
        ...address,
        isPendingReview: true,
        preferredDropLocationId: null,
      };

      await withRetry(() =>
        orderfulApi.updateAddressFind(dropLocationInfoId, updatedAddress)
      );

      await Promise.all(
        dropLocations.map((dropLocation) =>
          withRetry(() => updateDropLocationWithRemark(dropLocation, reason))
        )
      );

      await withRetry(() =>
        orderfulApi.createAddressFindRemark(dropLocationInfoId, {
          addressFindId: dropLocationInfoId,
          message: reason,
          isVisibleToCustomer: false,
        })
      );

      setAddressInfoForOrderMap({
        ...addressInfoForOrderMap,
        [orderId]: updatedAddress
      }); //Update locally stored addressInfo 

      if (selectedCellId !== espooCellId) {
        onClickShowSuggestedDropModalForOrder(orderId);
      } 

    } catch (error) {

      closeSuggestedDropPointConfirmationModal();

      logToDatadog('error_handleRequestDropLocationReview', {error}, 'error');

      notify({
        variant: 'error',
        message: 'Error Invalidating Drop Location'
      });
    } finally {
      dispatch(setInvalidatingAnOrderDropLocation(false));
    }
  };


  const updateDropLocationWithRemark = async (
    dropLocation: DropLocation,
    reason: string
  ) => {
    if (!dropLocation?.id || !reason) {

      closeSuggestedDropPointConfirmationModal();

      logToDatadog('error_updateDropLocationWithRemark_invalid_state', {}, 'error');
      notify({
        variant: 'error',
        message: 'Error Invalidating Drop Location'
      });
      return;
    }

    const timeSince1970InSeconds = new Date().getTime() / 1000;
    const newId = Math.floor(timeSince1970InSeconds);

    const timestamp = new Date().toISOString();

    const newRemark = {
      id: newId,
      createDate: timestamp,
      createdBy: dropLocation.locationId,
      reason,
    };

    const updatedDropLocation = {
      ...dropLocation,
      remarks: [...dropLocation.remarks, newRemark],
      suggestedForAddressFindId: null,
    };

    try {
      await deliveryApi.updateDropLocation(dropLocation.id, updatedDropLocation);
    } catch (error) {
      closeSuggestedDropPointConfirmationModal();

      logToDatadog('error_updateDropLocationWithRemark_updateDropLocation', { error }, 'error');
      notify({
        variant: 'error',
        message: 'Error Invalidating Drop Location'
      });
    }
  };

  const closeSuggestedDropPointConfirmationModal = () => {
    dispatch(setRouteConfirmationOrder(null));
    clearSelectedOrder();

    const isViewingOrderDetails = selectedTab === 1;
    if (isViewingOrderDetails) {
      setSelectedTab(0);  // go to the map tab since we've cleared the selected order above
    }
  };

  // New modal handlers using local state
  const handleOpenRouteConfirmation = (order: Order) => {
    // Always open Route Confirmation (do not redirect to Suggest Drop Points)
    setModalState({
      type: 'route',
      order: order
    });
  };

  const handleCloseModal = () => {
    setModalState({ type: null, order: null });
  };

  const handleSearchOldOrders = (query: string) => {
    if (!selectedCellId) {
      notify({
        variant: 'error',
        message: 'Missing cellId'
      });
      return;
    }

    setIsSearchingOldOrders(true);
    
    orderfulApi.getOrderSummaryBySearchQuery(query)
    .then((response) => {

      if (response) {
        setOldOrdersData(response);
      }
    })
    .catch((error) => {

      logToDatadog('handleSearchOldOrders_failed', { error }, 'error');

      notify({
        variant: 'error',
        message: 'Error searching old orders'
      });
    }).finally(() => {
      setIsSearchingOldOrders(false);
    }) 
  };

  const handleToggleCompletedOrders = (show: boolean) => {
    setShowCompletedCancelledOrders(show);
  };

  const handleAlertClick = (orderId: string) => {
    // Select the order when an alert is clicked
    dispatch(setSelectedOrderId(orderId));
    // Switch to order details tab
    setSelectedTab(1);
  };

  // Update an order's landing zone via Orderful PATCH and refresh orders
  const updateLandingZoneForOrder = async (orderId: string, landingZoneId: string) => {
    try {
      // Prevent LZ changes when mission status disallows it
      const orderForUpdate = filteredOrders?.find(o => o.id === orderId);
      const missionStatus = (orderForUpdate as any)?.missionStatus || orderForUpdate?.mission?.status;
      if (missionStatus && !canChangeLandingZone(missionStatus)) {
        notify({ variant: 'error', message: 'Cannot change landing zone in current mission state' });
        return;
      }

      await orderfulApi.patchOrder(orderId, { landingZoneId });
      const zonesForCell = landingZonesByCell[selectedCellId] || [];
      const selectedZone = zonesForCell.find(z => z.id === landingZoneId);
      notify({ variant: 'success', message: 'Landing zone updated' });
      // Optimistic local update (UI reflects immediately; SSE will reconcile)
      dispatch(updateLandingZoneLocally(orderId, landingZoneId, selectedZone?.name));
    } catch (error) {
      logToDatadog('updateLandingZoneForOrder_failed', { error, orderId, landingZoneId }, 'error');
      notify({ variant: 'error', message: 'Error updating landing zone' });
    }
  };

  return (
    <Paper sx={{
      height: '100vh',
      flexDirection: 'row'
    }}>
      <Box
        display="flex"
        flexDirection="row"
        sx={{ height: '100vh', width: '100vw' }}>
        <Box
          display="flex"
          flexDirection={'column'}
          maxWidth={6000}
          minWidth={'50%'}
          sx={{
            overflowX: 'scroll'
          }}>

          <OrderHubHeader
            selectedCellId={selectedCellId}
            handleCellUpdate={handleCellUpdate}
            cells={cells}
            refreshInterval={refreshInterval}
            handleRefreshTimeChange={handleRefreshTimeChange}
            timeFilter={timeFilter}
            handleSinceMinutesQuery={handleSinceMinutesQuery}
            onSearchButtonClicked={() => {
              setShouldShowSearchModal(true);
            }}
            useSSEForOrders={useSSEForOrders}
            isConnected={isConnected}
            showCompletedOrders={showCompletedCancelledOrders}
            onToggleCompletedOrders={handleToggleCompletedOrders}
          />
          <Box
            display="flex"
            borderTop={1}
            p={1}
            flex={1}
            maxWidth={6000}
            flexDirection={'row'}
            style={{
              overflowX: 'scroll',
              overflowY: 'hidden',
              paddingTop: 8
            }}>
            <Box
              id="test1"
              style={{ width: 280 }}
              sx={{
                '&::-webkit-scrollbar': {
                  display: 'none'
                }
              }}>
              <Box display="flex" py={2} style={{ width: 280 }}>
                <h3 className={'text-lg font-semibold text-gray-800'}>
                  New/Scheduled ({newOrders.length})
                </h3>
              </Box>
              <Box
                display="flex"
                flexDirection={'column'}
                sx={{
                  width: 280,
                  height: 'calc(100% - 80px)',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  '&::-webkit-scrollbar': {
                    width: 0,
                    display: 'none'
                  },
                  overflowY: 'scroll',
                  overflowX: 'hidden'
                }}>
                <OrderList
                  orders={newOrders}
                  onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                  onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                  onOpenRouteConfirmation={handleOpenRouteConfirmation}
                  updateLandingZoneForOrder={updateLandingZoneForOrder}
                  landingZones={landingZonesByCell[selectedCellId] || []}
                  pads={pads}
                  openSuggestModal={() => setIsSuggestModalOpen(true)}
                  onAcceptOrder={(order) => acceptOrder(order, 0)}
                />
              </Box>
            </Box>
            {size[0] < 1900 ? (
              <>
                <Box style={{ width: 280 }}>
                  <Box display="flex" py={2}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      With Outlet ({withOutletOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={withOutletOrders}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
                <Box style={{ width: 280 }}>
                  <Box display="flex" py={2}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      Ready To Go ({readyToGoOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={readyToGoOrders}
                      groupOrdersByLandingZone={true}
                      showPadGrouping={true}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
              </>
            ) : (
              <>
                <Box
                  style={{ width: 280 }}
                  sx={{
                    '&::-webkit-scrollbar': {
                      display: 'none'
                    }
                  }}>
                  <Box display="flex" py={2} style={{ width: 280 }}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      Accepted ({toAcceptOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={toAcceptOrders}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                 </Box>
                </Box>
                <Box style={{ width: 280 }}>
                  <Box display="flex" py={2} style={{ width: 280 }}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      Store Preparing ({preparingOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={preparingOrders}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
                <Box style={{ width: 280 }}>
                  <Box display="flex" py={2} style={{ width: 280 }}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      Store Prepared ({preparedOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={preparedOrders}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
                <Box flexDirection="column" style={{ width: 280 }}>
                  <Box
                    display="flex"
                    py={2}
                    flexDirection="row"
                    alignItems={'start'}>
                    <h3 className={'text-lg font-semibold text-gray-800'}>
                      Received ({receivedOrders.length})
                    </h3>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={'column'}
                    sx={{
                      width: 280,
                      height: 'calc(100% - 80px)',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0,
                        display: 'none'
                      },
                      overflowY: 'scroll',
                      overflowX: 'hidden'
                    }}>
                    <OrderList
                      orders={receivedOrders}
                      groupOrdersByLandingZone={true}
                      showPadGrouping={false}
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder}
                      onClickInvalidateDropLocation={onClickInvalidateDropLocation}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      updateLandingZoneForOrder={updateLandingZoneForOrder}
                      landingZones={landingZonesByCell[selectedCellId] || []}
                      pads={pads}
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
                <Box display="flex" flexDirection="column" flex={1}>
                  <Box
                    display={'flex'}
                    flex={1}
                    maxHeight="94%"
                    sx={{
                      overflowY: 'scroll',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': {
                        width: 0
                      }
                    }}>
                    <UpcomingOrders 
                      onClickShowSuggestedDropModalForOrder={onClickShowSuggestedDropModalForOrder} 
                      updateLandingZoneForOrder={updateLandingZoneForOrder} 
                      landingZones={landingZonesByCell[selectedCellId] || []} 
                      pads={pads} 
                      openSuggestModal={() => setIsSuggestModalOpen(true)}
                      showPadGrouping={true}
                      onOpenRouteConfirmation={handleOpenRouteConfirmation}
                      onAcceptOrder={(order) => acceptOrder(order, 0)}
                    />
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
        <Box
          style={{
            width: '100%',
            overflowX: 'scroll',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
          borderLeft={8}
          borderColor="#D9DBE9"
          display="flex"
          flexDirection={'column'}>
          <Box display="flex" sx={{ height: '6%', overflow: 'hidden', position: 'relative' }}>
            <Paper style={{ height: '100%', width: '100%', position: 'relative' }}>
              <Tabs
                value={selectedTab}
                onChange={onChangeTab}
                indicatorColor="primary"
                scrollButtons="auto"
                variant="scrollable"
                textColor="primary">
                {tabConfig.map(list => (
                  <Tab
                    key={`orderhub-tab-${list.index}`}
                    label={list.title}
                    {...a11yProps(list.index)}
                    disabled={list.index === 1 ? !(currentlySelectedOrdersOrderDetails) : null}
                  />
                ))}
              </Tabs>
              {/* Hidden click area to enable Custom tab - requires 5 clicks */}
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  width: '30px',
                  height: '30px',
                  opacity: 0,
                  cursor: 'default',
                  zIndex: 1000
                }}
                onClick={() => {
                  const newClickCount = clickCount + 1;
                  console.log(`Click ${newClickCount} detected`);
                  setClickCount(newClickCount);
                  
                  if (newClickCount >= 5) {
                    console.log('5 clicks reached! Enabling Custom tab...');
                    setShowCustomTab(true);
                    setClickCount(0);
                    console.log('Custom tab enabled - showCustomTab:', true);
                  }
                  
                  // Reset click count after 3 seconds of inactivity
                  setTimeout(() => {
                    console.log('Resetting click count after timeout');
                    setClickCount(0);
                  }, 3000);
                }}
                title={clickCount > 0 ? `${5 - clickCount} more clicks to enable Custom tab` : ''}
              />
            </Paper>
          </Box>
          <Box display="flex" sx={{ height: '94%', width: '100%' }}>
            <Paper style={{ height: '100%', width: '100%' }}>
              {selectedTab === 0 && (<OrdersMap />)}

              {currentlySelectedOrderId && selectedTab === 1 && (
                <OrderDetails 
                  onOpenRouteConfirmation={handleOpenRouteConfirmation} 
                  openSuggestModal={() => setIsSuggestModalOpen(true)}
                  deprecatedOrderCardProps={{
                    addressFind: addressInfoForOrderMap?.[currentlySelectedOrderId],
                    isBackGardenDelivery: isBackGardenDelivery,
                    onClickShowSuggestedDropModalForOrder: onClickShowSuggestedDropModalForOrder,
                    onClickInvalidateDropLocation: onClickInvalidateDropLocation,
                    updateLandingZoneForOrder: updateLandingZoneForOrder,
                    landingZones: landingZonesByCell[selectedCellId] || [],
                    pads: pads
                  }}
                />
              )}
              {selectedTab === 2 && ( <CellAvailabilityOverview onSelectOrder={(orderId: string) => {
                dispatch(setSelectedOrderId(orderId));
              }} /> )}
              {selectedTab === 3 && <Availability />}
              {selectedTab === 4 && <Teams pads={pads} isLoading={padsLoading} error={padsError} />}
              {selectedTab === 5 && (
                <Box
                  display="flex"
                  style={{ position: 'fixed', height: '100%', width: '100%' }}>
                  <CustomView edit={edit} viewKey="timetable">
                    <h6 className="text-xs font-bold text-gray-600">Timetable</h6>
                    <CellAvailabilityOverview onSelectOrder={(orderId) => { dispatch(setSelectedOrderId(orderId))}} />
                  </CustomView>

                  <CustomView edit={edit} viewKey="map">
                    <h6 className="text-xs font-bold text-gray-600">Map</h6>
                    <OrdersMap />
                  </CustomView>

                  <CustomView edit={edit} viewKey="order">
                    <h6 className="text-xs font-bold text-gray-600">Order</h6>
                    {currentlySelectedOrderId ? (
                      <OrderDetails 
                        onOpenRouteConfirmation={handleOpenRouteConfirmation} 
                        openSuggestModal={() => setIsSuggestModalOpen(true)}
                        deprecatedOrderCardProps={{
                          addressFind: addressInfoForOrderMap?.[currentlySelectedOrderId],
                          isBackGardenDelivery: isBackGardenDelivery,
                          onClickShowSuggestedDropModalForOrder: onClickShowSuggestedDropModalForOrder,
                          onClickInvalidateDropLocation: onClickInvalidateDropLocation,
                          updateLandingZoneForOrder: updateLandingZoneForOrder,
                          landingZones: landingZonesByCell[selectedCellId] || [],
                          pads: pads
                        }}
                      />
                    ) : null}
                  </CustomView>
                  <CustomView edit={edit} viewKey="devices">
                    <h6 className="text-xs font-bold text-gray-600">Devices</h6>
                    <Teams pads={pads} isLoading={padsLoading} error={padsError} />
                  </CustomView>
                  <FormGroup
                    style={{
                      zIndex: 0,
                      paddingLeft: 20,
                      width: 100,
                      height: 50
                    }}>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Edit"
                      value={edit}
                      onChange={changeEditMode}
                    />
                  </FormGroup>
                </Box>
              )}
            </Paper>
          </Box>
        </Box>
      </Box>

      {/* Render modals based on local state */}
      {modalState.type === 'route' && modalState.order && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 16,
              right: 16,
              zIndex: 2000,
              background: 'white',
              borderRadius: 8,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              padding: 6,
              display: 'flex',
              gap: 6
            }}
          >
            <Button
              size="small"
              variant={routeConfirmationVariant === 'new' ? 'contained' : 'outlined'}
              onClick={() => setRouteConfirmationVariant('new')}
            >
              New
            </Button>
            <Button
              size="small"
              color="warning"
              variant={routeConfirmationVariant === 'deprecated' ? 'contained' : 'outlined'}
              onClick={() => setRouteConfirmationVariant('deprecated')}
            >
              Deprecated
            </Button>
          </div>

          {routeConfirmationVariant === 'new' ? (
            <NewRouteConfirmation
              order={modalState.order}
              onClose={handleCloseModal}
              open
            />
          ) : (
            <RouteConfirmation
              order={modalState.order}
              handleClose={handleCloseModal}
              geofences={geofences}
            />
          )}
        </>
      )}
      {modalState.type === 'dropPoint' && modalState.order && (
        <SuggestedDropPointConfirmationModal
          order={modalState.order}
          obstacles={obstacles}
          eircode={modalState.order.eircode}
          handleClose={handleCloseModal}
          geofences={geofences}
        />
      )}

      {shouldShowSearchModal ? <SearchModal<Order | OrderSummary>
        onSelect={(selectedOrder) => {
          dispatch(setSelectedOrderId(selectedOrder?.id));
          setShouldShowSearchModal(false);
          // Clear old orders data when modal closes
          setOldOrdersData([]);
        }}
        displayValues={filteredOrders}
        filterProperties={['id', 'eircode', 'external_order_id', 'external_reference_id']}
        onDismiss={() => {
          setShouldShowSearchModal(false);
          // Clear old orders data when modal closes
          setOldOrdersData([]);
        }}
        getDisplayNameForValue={(val) => {
          return (<div>
            <p>#{getShortIdForOrder(val)} for {val.eircode}</p>
            <p>{val.status}</p>
          </div>)
        }}
        onSearchOldOrders={handleSearchOldOrders}
        isSearchingOldOrders={isSearchingOldOrders}
        oldOrdersData={oldOrdersData}
      /> : <></>}

      {/* Place Drop Point Modal */}
      <PlaceDropPointModal
        isOpen={isSuggestModalOpen}
        onClose={() => setIsSuggestModalOpen(false)}
        initialEircode={currentlySelectedOrdersOrderDetails?.eircode}
        title={'Delivery Spot Management'}
        suggestedDropPointLatLon={currentlySelectedOrdersOrderDetails?.requestedDropPos}
      />

      {/* Order Alerts Popup - Intercom Style */}
      <OrderAlertsPopup
        alerts={alerts}
        isConnected={alertsConnected}
        error={alertsError}
        onDismissAlert={dismissAlert}
        onClearAll={clearAlerts}
        onAlertClick={handleAlertClick}
      />
    </Paper>
  );
};

const mapStateToProps = state => ({
  geofences: state.geofences.geofences,
  ordersToFilter: state.orders.ordersToFilter,
  createdOrders: state.orders.createdOrders,
  loading: state.orders.loading,
  mergedOrders: state.orders.mergedOrders,
  acceptingOrderWithEta: state.orders.acceptingOrderWithEta,
  rejectingOrder: state.orders.rejecting,
  refundingOrder: state.orders.refunding,
  resettingOrderCapacity: state.orders.resettingOrderCapacity,
  timeFilter: state.orders.timeFilter,
  cells: state.orders.cells,
  selectedCellId: state.orders.selectedCellId,
  regions: state.admin.regions,
  refreshInterval: state.orders.refreshInterval,
  obstacles: state.obstacles.list,
});

const mapDispatchToProps = dispatch => ({
  moveOrderAcceptedForTime: (orderId, time) =>
    dispatch(moveOrderAcceptedForTime(orderId, time)),
  getGeofences: () => dispatch(getGeofences()),
  setOrderWithinTime: sinceMinutes =>
    dispatch(setOrderWithinTimeFilter(sinceMinutes)),
  setSelectedCell: (cellId, useSSEForOrders) => dispatch(setSelectedCell(cellId, useSSEForOrders)),
  requestOrder: orderId => dispatch(getOrder(orderId)),
  resetOrder: order => dispatch(resetOrder(order)),
  requestMission: missionId => dispatch(getMission(missionId)),
  setOrderStatus: (orderId, status) =>
    dispatch(updateOrderStatus(orderId, status)),
  rejectOrder: reason => dispatch(rejectOrder(reason)),
  refundOrder: (order, amount, reason) =>
    dispatch(refundOrder(order, amount, reason)),
  mergeOrders: merge => dispatch(mergeOrders(merge)),
  getMergedOrders: linkedOrderIds => dispatch(getMergedOrders(linkedOrderIds)),
  clearSelectedOrder: () => dispatch(clearSelectedOrder()),
  addNoteToOrder: (note, orderId) => dispatch(addNoteToOrder(note, orderId)),
  getAdminConfig: () => dispatch(getAdminConfig()),
  getCells: () => dispatch(getCells()),
  getMerchantsInCell: (cellId: number) => dispatch(getMerchantsInCell(cellId)),
  getRegions: () => dispatch(getRegions()),
  setRefreshInterval: interval => dispatch(setRefreshInterval(interval)),
  notify: notification => dispatch(newNotification(notification)),
  getCellCommercialConfig: (cellId: number) => dispatch(getCellCommercialConfig(cellId)),
  setShowCompletedCancelledOrders: (show: boolean) => dispatch(setShowCompletedCancelledOrders(show)),
  acceptOrder: (order, delayInMinutes) => dispatch(acceptOrder(order, delayInMinutes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderHub);
